export default "__VITE_ASSET__frZL$Evf__"